import { render, staticRenderFns } from "./DataPokok.vue?vue&type=template&id=55492b27&scoped=true&"
import script from "./DataPokok.vue?vue&type=script&lang=js&"
export * from "./DataPokok.vue?vue&type=script&lang=js&"
import style1 from "./DataPokok.vue?vue&type=style&index=1&id=55492b27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55492b27",
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPage,QCard,QCardSection,QBtn,QMarkupTable,QInput,QIcon,QPagination,QDialog,QSelect,QBtnToggle});
